import { render, staticRenderFns } from "./OdontogramaDetalle.vue?vue&type=template&id=3c828af7&scoped=true"
import script from "./OdontogramaDetalle.vue?vue&type=script&lang=js"
export * from "./OdontogramaDetalle.vue?vue&type=script&lang=js"
import style0 from "./OdontogramaDetalle.vue?vue&type=style&index=0&id=3c828af7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c828af7",
  null
  
)

export default component.exports